import { TableRow, useTheme } from "@mui/material";
import { Row } from "@tanstack/react-table";

export const HoverRow = <T,>(
    props: React.PropsWithChildren<
        Row<T> & { selected?: boolean; clickable?: boolean; onClick?: (e: React.MouseEvent<HTMLTableRowElement>) => void }
    >,
) => {
    const theme = useTheme();
    const clickable = props.clickable !== false;

    // Rows are flat: they inherit the table container background in both themes and are
    // distinguished only by hover and selection (see the table layout notes in CLAUDE.md).
    const defaultBackground = "transparent";

    const selectedBackground = theme.palette.emteria.background.selectedRow;
    const hoverBackground = theme.palette.emteria.background.listHover;

    return (
        <TableRow
            style={{
                cursor: clickable ? "pointer" : "default",
                backgroundColor: props.selected ? selectedBackground : defaultBackground,
            }}
            onClick={props.onClick}
            onMouseEnter={(e) => {
                if (!props.selected) {
                    e.currentTarget.style.backgroundColor = hoverBackground;
                }
            }}
            onMouseLeave={(e) => {
                if (!props.selected) {
                    e.currentTarget.style.backgroundColor = defaultBackground;
                }
            }}
        >
            {props.children}
        </TableRow>
    );
};
